import { useFormikContext } from "formik";
import {
  IconBuildingCommunity,
  IconBuildingStore,
  IconBuildingWarehouse,
  IconHome,
} from "@tabler/icons-react";
import Text from "../../UI/Text";
// @ts-expect-error pure js
import Tabs from "../../UI/Tabs";
import ChoiceCard from "./ChoiceCard";
import styles from "./TypeBienForm.module.css";

interface TypeBienFormValues {
  type?: string;
  is_immeuble?: boolean;
}

export default function TypeBienForm() {
  const { selectTab } = Tabs.useActiveTab();
  const { values, setFieldValue } = useFormikContext<TypeBienFormValues>();

  // Un immeuble est stocké comme une habitation : la carte déjà choisie ne se
  // déduit pas du seul champ `type`
  const currentType = values.is_immeuble ? "immeuble" : values.type;

  function next(type: string) {
    if (type !== currentType) {
      // Revenir ici pour changer de type doit repartir d'une base propre : les
      // champs saisis dans les étapes de l'ancien type pilotent les onglets
      // suivants (`is_immeuble`) et seraient sinon envoyés au back, où
      // `nb_rooms` créerait une colocation et `is_coloc` un bail de coloc.
      setFieldValue("is_immeuble", false);
      setFieldValue("is_coloc", false);
      setFieldValue("nb_rooms", 0);
      setFieldValue("appartements", []);
    }

    let nextTab = "";
    switch (type) {
      case "habitation":
        nextTab = "type-logement";
        break;
      case "immeuble":
        nextTab = "nb-apparts";
        setFieldValue("is_immeuble", true);
        setFieldValue("type", "habitation");
        selectTab(nextTab, true);
        return;
      case "garage":
        nextTab = "bien";
        break;
      case "commercial":
        nextTab = "bien";
        break;
      default:
        nextTab = "bien";
    }
    setFieldValue("type", type);
    setFieldValue("type_indice", type === "garage" ? "IRL" : "");
    selectTab(nextTab, true);
  }

  return (
    <div className={styles.step}>
      <Text>Choisissez le type de bien à ajouter</Text>
      <ChoiceCard
        icon={IconHome}
        title={"Local à usage d'habitation"}
        subtitle={"Maison, appartement, chambre"}
        onClick={() => next("habitation")}
      />
      <ChoiceCard
        icon={IconBuildingStore}
        title={"Local à usage commercial ou professionnel"}
        subtitle={"Bureau, boutique, local pro"}
        onClick={() => next("commercial")}
      />
      <ChoiceCard
        icon={IconBuildingWarehouse}
        title={"Autre type de local"}
        subtitle={"Parking, garage, stockage, etc."}
        onClick={() => next("garage")}
      />
      <ChoiceCard
        icon={IconBuildingCommunity}
        iconColor="orange"
        title={"Immeuble"}
        subtitle={"Créer plusieurs appartements d'un coup"}
        onClick={() => next("immeuble")}
      />
    </div>
  );
}
